import { css } from "styled-components";
import { mapRecord } from "./mapRecord";
import { CommonCssType } from "./types";

const rulesetToColorMapping = {
  primaryActive: css`
    color: var(--color-primary-900);
  `,
  primaryInactive: css`
    color: var(--color-primary-400);
  `,
  primaryDisabled: css`
    color: var(--color-primary-200);
  `,
  link: css`
    color: var(--color-secondary-800);
    text-decoration: none;
    &:visited {
      color: var(--color-accent-beta-700);
    }
    &:hover {
      color: var(--color-secondary-600);
    }
  `,
  linkDisabled: css`
    color: var(--color-secondary-500-disabled);
    text-decoration: none;
  `,
  warning: css`
    color: var(--color-warning-800);
  `,
  error: css`
    color: var(--color-error-500);
  `,
  success: css`
    color: var(--color-success-800);
  `,
  whiteActive: css`
    color: var(--color-neutral-000-full);
  `,
  whiteInactive: css`
    color: var(--color-neutral-000-inactive);
  `,
  whiteDisabled: css`
    color: var(--color-neutral-000-disabled);
  `,
};

type buildRulesetsArgs = {
  fontFamily: CommonCssType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- different for alpha & numeric rulesets
  textStyleToSizeMapping: Record<any, CommonCssType>;
};

export const buildRulesets = ({
  fontFamily,
  textStyleToSizeMapping,
}: buildRulesetsArgs) => {
  const buildRuleset = (colors: CommonCssType) => {
    const buildRulesForTextStyle = (sizing: CommonCssType) => css`
      ${fontFamily};
      ${sizing};
      ${colors};
    `;

    return mapRecord(textStyleToSizeMapping, buildRulesForTextStyle);
  };

  return mapRecord(rulesetToColorMapping, buildRuleset);
};
